<div class="main-content beautician-prospecting-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
					<div class="card">
						<div class="card-header card-header-{{ color }}-6">
						<h4 class="card-title">Salon Prospects</h4>
						<p class="card-category mb-0">NYS licensed salon businesses, matches, and sales assignments.</p>
					</div>

					<div class="card-body">
						<form [formGroup]="formGroup" (ngSubmit)="runReport()">
							<div class="row g-3">
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Show</mat-label>
										<mat-select formControlName="mode">
											<mat-option value="prospects">Unmatched licensed businesses</mat-option>
											<mat-option value="conversions">Conversions</mat-option>
											<mat-option value="matched">Existing customers (matched)</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>License type</mat-label>
										<mat-select formControlName="ltype">
											<mat-option *ngFor="let o of ltypeOptions" [value]="o.value">{{ o.label }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-3" *ngIf="repOptions.length">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>ZIP owner</mat-label>
										<mat-select formControlName="reps" multiple>
											<mat-option *ngFor="let r of repOptions" [value]="r">{{ r }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-3" *ngIf="isProspect">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Min ops</mat-label>
										<input matInput type="number" formControlName="min_ops" min="0">
									</mat-form-field>
								</div>

								<div class="col-12 d-flex flex-wrap gap-2 align-items-center">
									<button mat-raised-button color="primary" type="submit" [disabled]="loading">Refresh</button>
									<a *ngIf="excellink && dataSource.data.length" [href]="excellink" target="_blank" mat-stroked-button>
										<i class="fa fa-file-excel-o"></i> Excel
									</a>
									<a *ngIf="pdflink && dataSource.data.length" [href]="pdflink" target="_blank" mat-stroked-button>
										<i class="fa fa-file-pdf-o"></i> PDF
									</a>
									<span class="text-muted ms-2" *ngIf="loading">Loading&hellip;</span>
								</div>
							</div>
						</form>

						<div class="bp-summary mt-3" *ngIf="byrepKeys.length">
							<span><strong>{{ count | number }}</strong> {{ countLabel }}</span>
							<span class="mx-2">·</span>
							<span class="bp-chip">Assigned: <strong>{{ scratchAssigned | number }}</strong></span>
							<span class="bp-chip">Converted: <strong>{{ scratchConverted | number }}</strong></span>
							<button class="bp-chip bp-chip-button" type="button" *ngIf="(formGroup.get('reps')?.value || []).length" (click)="clearRepFilter()">
								All ZIP owners
							</button>
							<button class="bp-chip bp-chip-button" type="button" *ngFor="let k of byrepKeys" [class.is-active]="isRepSelected(k)" (click)="selectRep(k)">
								{{ k }}: <strong>{{ byrep[k] | number }}</strong>
							</button>
						</div>

						<div class="bp-map mt-3" *ngIf="mapData.length">
							<div class="bp-map-canvas-wrap">
								<div #mapHost class="bp-map-host"></div>
								<svg #lassoCanvas class="bp-lasso" hidden>
									<path class="bp-lasso-path" fill="rgba(181,84,30,0.18)" stroke="#b5541e" stroke-width="2.5"></path>
								</svg>

								<!-- draw palette (top-left) -->
								<div class="bp-draw-palette" *ngIf="scratchEnabled">
									<button type="button" [class.is-active]="lassoMode === 'add'" (click)="startLasso(false)" title="Lasso to select prospects">
										<i class="material-icons" aria-hidden="true">gesture</i><span>Lasso</span>
									</button>
									<button type="button" [class.is-active]="lassoMode === 'remove'" [disabled]="!selectedKeys.size" (click)="startLasso(true)" title="Lasso to unselect">
										<i class="material-icons" aria-hidden="true">highlight_alt</i><span>Remove</span>
									</button>
								</div>

								<!-- plotted count (top-right) -->
								<div class="bp-map-count">{{ mapCount | number }} plotted</div>

								<!-- draw hint (top-center) -->
								<div class="bp-draw-hint" *ngIf="drawHint">{{ drawHint }}</div>

								<!-- layer toggle (bottom-left) -->
								<div class="bp-layer-toggle">
									<button type="button" [class.is-active]="mapTypeId === 'roadmap'" (click)="setMapType('roadmap')" title="Road map">
										<i class="material-icons" aria-hidden="true">map</i><span>Map</span>
									</button>
									<button type="button" [class.is-active]="mapTypeId === 'hybrid'" (click)="setMapType('hybrid')" title="Satellite">
										<i class="material-icons" aria-hidden="true">satellite</i><span>Satellite</span>
									</button>
								</div>

								<!-- selection action bar (bottom-center) -->
								<div class="bp-sel-bar" *ngIf="selectedKeys.size">
									<span class="bp-sel-count"><strong>{{ selectedKeys.size | number }}</strong> selected</span>
									<select class="bp-sel-select" [(ngModel)]="assignRep" [ngModelOptions]="{standalone: true}" [disabled]="!scratchEnabled">
										<option value="">Assign to…</option>
										<option *ngFor="let r of repOptions" [value]="r">{{ r }}</option>
									</select>
									<button type="button" class="bp-btn-primary" [disabled]="!scratchEnabled || !assignRep" (click)="assignSelected()">Assign</button>
									<button type="button" class="bp-btn-ghost" [disabled]="!scratchEnabled" (click)="clearSelectedAssignments()">Unassign</button>
									<button type="button" class="bp-btn-ghost" (click)="clearSelection()">Clear</button>
								</div>
							</div>
							<div class="bp-map-status" *ngIf="mapStatus">{{ mapStatus }}</div>
						</div>

						<div class="table-responsive mt-3" *ngIf="dataSource.data.length">
							<table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" class="w-100">
								<!-- convert to customer (prospects only) -->
								<ng-container matColumnDef="convert">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let r">
										<button type="button" mat-stroked-button color="primary" class="bp-convert-btn"
											(click)="convertProspect(r, $event)" title="Add this salon as a new customer">
											<i class="material-icons" aria-hidden="true">person_add</i> Convert
										</button>
									</td>
								</ng-container>
								<!-- possible existing customer (flag; prospects only) -->
								<ng-container matColumnDef="possible_dup">
									<th mat-header-cell *matHeaderCellDef>Possible dup?</th>
									<td mat-cell *matCellDef="let r">
										<span *ngIf="r.possible_dup_debtorno" class="bp-dup-flag"
											title="Looks like an existing customer at this address — verify before calling">
											<i class="material-icons" aria-hidden="true">warning</i>
											#{{ r.possible_dup_debtorno }} {{ r.possible_dup_name }}
										</span>
									</td>
								</ng-container>
								<!-- shared -->
								<ng-container matColumnDef="rep">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>ZIP Owner</th>
									<td mat-cell *matCellDef="let r">{{ r.rep }}</td>
								</ng-container>
								<ng-container matColumnDef="matched_rep">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Rep</th>
									<td mat-cell *matCellDef="let r">{{ r.matched_rep }}</td>
								</ng-container>
								<ng-container matColumnDef="assignment_rep">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned</th>
									<td mat-cell *matCellDef="let r">{{ r.assignment_rep }}</td>
								</ng-container>
								<ng-container matColumnDef="business_name">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
									<td mat-cell *matCellDef="let r">{{ r.business_name }}</td>
								</ng-container>
								<ng-container matColumnDef="est_potential">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Est. $/yr</th>
									<td mat-cell *matCellDef="let r">{{ r.est_potential ? ('$' + (r.est_potential | number:'1.0-0')) : '' }}</td>
								</ng-container>
								<ng-container matColumnDef="est_twin">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Looks like</th>
									<td mat-cell *matCellDef="let r">
										<span *ngIf="r.est_twin">{{ r.est_twin }}<span class="bp-twin-val" *ngIf="r.est_twin_ttm"> · ${{ r.est_twin_ttm | number:'1.0-0' }}</span></span>
									</td>
								</ng-container>
								<ng-container matColumnDef="owner">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Owner</th>
									<td mat-cell *matCellDef="let r">{{ r.owner }}</td>
								</ng-container>
								<ng-container matColumnDef="address">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
									<td mat-cell *matCellDef="let r">{{ r.address }}<span *ngIf="r.suite"> {{ r.suite }}</span></td>
								</ng-container>
								<ng-container matColumnDef="city">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
									<td mat-cell *matCellDef="let r">{{ r.city }}</td>
								</ng-container>
								<ng-container matColumnDef="zip5">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
									<td mat-cell *matCellDef="let r">{{ r.zip5 }}</td>
								</ng-container>
								<ng-container matColumnDef="license_number">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>License #</th>
									<td mat-cell *matCellDef="let r">{{ r.license_number }}</td>
								</ng-container>
								<!-- prospects -->
								<ng-container matColumnDef="license_type">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
									<td mat-cell *matCellDef="let r">{{ ltypeLabel(r.license_type) }}</td>
								</ng-container>
								<ng-container matColumnDef="ops_at_addr">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Ops @ Addr</th>
									<td mat-cell *matCellDef="let r">{{ r.ops_at_addr }}</td>
								</ng-container>
								<ng-container matColumnDef="license_issue_date">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Licensed Since</th>
									<td mat-cell *matCellDef="let r">{{ r.license_issue_date }}</td>
								</ng-container>
								<ng-container matColumnDef="license_expiration_date">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Expires</th>
									<td mat-cell *matCellDef="let r">{{ r.license_expiration_date }}</td>
								</ng-container>
								<!-- matched -->
								<ng-container matColumnDef="matched_debtorno">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>AA Debtor #</th>
									<td mat-cell *matCellDef="let r">{{ r.matched_debtorno }}</td>
								</ng-container>
								<ng-container matColumnDef="matched_name">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>AA Customer</th>
									<td mat-cell *matCellDef="let r">{{ r.matched_name }}</td>
								</ng-container>
								<ng-container matColumnDef="last_order">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Order</th>
									<td mat-cell *matCellDef="let r">{{ r.last_order }}</td>
								</ng-container>
								<ng-container matColumnDef="ttm_sales">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>TTM Sales $</th>
									<td mat-cell *matCellDef="let r">{{ r.ttm_sales | number:'1.0-0' }}</td>
								</ng-container>

								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: displayedColumns"
									class="bp-table-row"
									[class.is-active]="activeRowKey === (row.prospect_key || row.license_number || '')"
									tabindex="0"
									(mouseenter)="previewRowOnMap(row)"
									(mouseleave)="clearRowPreview(row)"
									(click)="focusRowOnMap(row)"
									(keydown)="onTableRowKeydown($event, row)"></tr>
							</table>
							<mat-paginator [length]="count" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[50, 100, 250, 500]" (page)="onPage($event)" showFirstLastButtons></mat-paginator>
						</div>

						<p class="text-muted mt-3 mb-0" *ngIf="ran && !loading && !dataSource.data.length">
							No records for the selected filters.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
